import { categories } from "@/mocks/articles";

export default function StatsSection() {
  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-950 rounded-2xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary-500 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-72 h-72 bg-accent-500 rounded-full blur-3xl"></div>
          </div>

          <div className="relative z-10">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                为什么选择黑料官网？
              </h2>
              <p className="text-sm text-background-400 max-w-xl mx-auto">
                我们坚持真实、快速、深度的内容理念，成为千万用户信赖的爆料平台
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {[
                { icon: "ri-spy-line", label: "独家爆料", value: "12,800+", desc: "累计独家内容" },
                { icon: "ri-user-smile-line", label: "活跃用户", value: "5,000万+", desc: "月活跃用户数" },
                { icon: "ri-flashlight-line", label: "极速报道", value: "24h", desc: "最快爆料响应" },
                { icon: "ri-shield-check-line", label: "真实可靠", value: "99.2%", desc: "内容真实率" },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <span className="w-12 h-12 rounded-full bg-background-50/10 flex items-center justify-center mx-auto mb-3">
                    <span className="w-6 h-6 flex items-center justify-center text-primary-400"><i className={`${stat.icon} text-xl`}></i></span>
                  </span>
                  <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">{stat.value}</div>
                  <div className="text-xs text-background-400 mb-0.5">{stat.label}</div>
                  <div className="text-xs text-background-500">{stat.desc}</div>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              {categories.slice(0, 4).map((cat) => (
                <div key={cat.slug} className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/5 border border-background-50/10">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-400"><i className={`${cat.icon} text-sm`}></i></span>
                  <span className="text-sm text-background-300 font-medium">{cat.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}